<script lang="ts">
	//Services
	import { format } from '../../../../../services/i18n';
	import { postReq } from '../../../../../services/http';

	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';

	//Helpers
	import { onSettingsResponse } from '../../../../../helpers/device_settings_helpers';

	//Types
	import type { Device } from '../../../../../types/Device';
	import type { SettingRequest } from '../../../../../types/requests/settings/setting';

	//Design system components
	import { Button, Input } from '@Shelly/shelly-design-system';

	export let device: Device;

	$: settingsStore = getDeviceSettings(device.id);
	$: settings = $settingsStore;
	const min = 5,
		max = 1440,
		unit = 'min';

	let loading = false,
		value = settings[device.category + 's'][0].boost_minutes,
		cache = value;

	$: error =
		value && (+value < min || +value > max)
			? $format('error_out_of_range', {
					default: `Value ${value} is out of range. Please provide a value within the limits. (${min} — ${max})`,
					values: { value, max, min, unit },
				})
			: '';

	const validateValue = (): void => {
		if (value < min) value = min;
		if (value > max) value = max;
	};

	const setBoostTime = async (): Promise<void> => {
		validateValue();
		if (cache !== value) {
			loading = true;
			const res: SettingRequest = await postReq(`/device/generic_command`, {
				id: device.id,
				command: 'valve',
				payload: JSON.stringify(
					{
						set_boost_minutes: +value,
						id: device.channel,
					},
					20000,
				),
			});
			onSettingsResponse(res, device);
			cache = value;
			loading = false;
		}
	};
</script>

<Input
	class="mb-s"
	bind:value
	type={'number'}
	{min}
	{max}
	{error}
	info={$format('boost_time_description', {
		values: { min, max },
		default: 'Set boost time in minutes. 0 will disable boost.',
	})}
	size="m"
	on:enter={setBoostTime}
	on:enter={validateValue}
	id="input-9r6tuc2"
	aria-label={$format('boost_time_description', {
		values: { min, max },
		default: 'Set boost time in minutes. 0 will disable boost.',
	})}
/>
<Button class="mt-s" {loading} size="m" width="full" on:click={setBoostTime}
	>{$format('button_save')}</Button
>
